export default "__VITE_ASSET__DuuMOg0r__"